
<div class="flex flex-col gap-6 min-w-[50vw] min-h-40 font-['Inter']">
  <div class="w-full flex flex-col gap-4">
    <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Edit one or more approvers <i>for this TA</i>.</div>
    <div class="flex gap-6 items-center">
      <span class="text-text-color text-lg font-semibold font-['Inter']">{{modalData()?.taNumber}}</span>
      <div class="flex gap-2 items-center">
        @if ((modalData()?.travellerCount ?? 0) > 1) {
          <i class="fa-solid fa-users"></i>
        } @else {
          <i class="fa-solid fa-user"></i>
        }
        <span class="text-text-color text-lg font-semibold font-['Inter']">{{modalData()?.primaryTraveller?.details?.name}}</span>
      </div>
      <span class="text-text-color text-sm font-normal font-['Inter']">{{'Travel Date: ' + ((modalData()?.startDate | date: 'dd/MM/yyyy') ?? '-')}}</span>
    </div>

    @if (timeline.length > 0) {
      <div class="flex flex-col gap-1">
        @for (line of timeline; track line.label) {
          <div class="flex gap-4 items-baseline text-sm font-normal font-['Inter']">
            <span class="text-nowrap font-bold">{{line.label + ':'}}</span>
            <span class="text-nowrap">{{line.date | date: 'dd/MM/yyyy'}}</span>
            @if (line.overdueAt) {
              <span class="text-nowrap font-bold">Overdue as of:</span>
              <span>{{line.overdueAt | date: 'dd/MM/yyyy'}}</span>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="w-full h-[1px] bg-surface-200"></div>

  <label class="font-semibold">Required Approvals</label>
  <p-table [value]="approverRows" [tableStyle]="{'min-width': '50rem'}" size="small">
    <ng-template #header>
      <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed']">
        <th>Approval Type</th>
        <th>Status</th>
        <th>Date/Time Approved</th>
        <th>Approver</th>
        <th class="w-80">Select New Approver</th>
      </tr>
    </ng-template>
    <ng-template #body let-row>
      <tr class="text-xs font-normal font-['Roboto_Condensed']">
        <td>{{row.label}}</td>
        <td>
          <p-badge [severity]="row.severity" [value]="row.status" class="w-20"></p-badge>
        </td>
        <td>
          <span class="text-nowrap">{{(row.actionedDate | date: 'dd/MM/yyyy  HH:mm:ss') ?? ''}}</span>
        </td>
        <td>
          <div class="flex flex-col">
            <span class="text-nowrap">{{row.approverName}}</span>
            <!-- Only set once the approver has been overridden, so it doubles as the "changed" marker. -->
            @if (row.approval.overrideDate) {
              <span class="text-nowrap text-[10px]">{{'Changed: ' + (row.approval.overrideDate | date: 'dd/MM/yyyy')}}</span>
            }
          </div>
        </td>
        <td class="min-w-52">
          @if (isEditable(row)) {
            <p-autocomplete [(ngModel)]="row.newApprover"
                            [dropdown]="true"
                            [suggestions]="filteredApprovers"
                            (completeMethod)="filterApprovers($event, row)"
                            (onClear)="clearNewApprover(row)"
                            [showClear]="true"
                            [disabled]="!isEditable(row)"
                            forceSelection
                            optionLabel="name"
                            placeholder="Type/Select name..."
                            appendTo="body"
                            class="w-full font-['Roboto_Condensed'] text-xs"
                            panelStyleClass="font-['Roboto_Condensed'] text-xs"
                            size="small">
            </p-autocomplete>
          }
        </td>
      </tr>
    </ng-template>
    <ng-template #footer>
      @if (approverRows.length === 0) {
        <tr class="text-xs font-normal font-['Roboto_Condensed']">
          <td colspan="5"><i>This TA has no required approvals.</i></td>
        </tr>
      }
    </ng-template>
  </p-table>

  <div class="flex-1"></div>
  <div class="w-full h-[1px] bg-surface-200 px-4"></div>
  <div class="flex justify-end gap-2">
    <p-button
      size="small"
      label="Save"
      severity="primary"
      icon="fa-regular fa-save"
      [disabled]="!hasChanges()"
      (click)="saveDialog()"
    />
    <p-button
      size="small"
      label="Cancel"
      severity="danger"
      icon="fa-regular fa-cancel"
      (click)="closeDialog()"
    />
  </div>
</div>
